import TtyIcon from '@mui/icons-material/Tty';
import HomeIcon from '@mui/icons-material/Home';
import StarIcon from '@mui/icons-material/Star';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import PowerIcon from '@mui/icons-material/Power';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import LanguageIcon from '@mui/icons-material/Language';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import InfoIcon from '@mui/icons-material/Info';
import MemoryIcon from '@mui/icons-material/Memory';

// constant
const icons = { HomeIcon, TtyIcon, StarIcon, MenuBookIcon,SmartphoneIcon,AddRoadIcon,PowerIcon,
    AirportShuttleIcon,ElectricBoltIcon,LanguageIcon,AutoModeIcon,
    PrecisionManufacturingIcon,InfoIcon,MemoryIcon };

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const other = {
    id: 'sample-docs-roadmap',
    type: 'group',
    children: [
        {
            id: 'sample-page1',
            title: 'Home',
            type: 'collapse',
            url: '',
            icon: HomeIcon,
            breadcrumbs: false,
            children: [
                {
                    id: 'digital',
                    title: 'Digital Transformation Solutions',
                    type: 'item',
                    url: '/dts',
                    icon: icons.MemoryIcon,
                    breadcrumbs: false
                },
                // {
                //     id: 'offroad',
                //     title: 'OffRoad Vehicle Systems',
                //     type: 'item',
                //     url: '/reusable',
                //     icon: icons.AddRoadIcon,
                //     breadcrumbs: false
                // },
                // {
                //     id: 'table',
                //     title: 'Powertrain - Drivetrain Solutions',
                //     type: 'item',
                //     url: '/powertrain',
                //     icon: icons.PowerIcon,
                //     breadcrumbs: false
                // },
                // {
                //     id: 'reusable',
                //     title: 'Commercial Vehicle Systems',
                //     type: 'item',
                //     url: '/commercial',
                //     icon: icons.AirportShuttleIcon,
                //     breadcrumbs: false
                // },
                // {
                //     id: 'electrical',
                //     title: 'Electrical - Electronic Systems',
                //     type: 'item',
                //     url: '/electrical',
                //     icon: icons.ElectricBoltIcon,
                //     breadcrumbs: false
                // },
                {
                    id: 'display',
                    title: 'Global Engineering Solutions',
                    type: 'item',
                    url: '/commercial',
                    icon: icons.LanguageIcon,
                    breadcrumbs: false
                },
                {
                    id: 'industry',
                    title: 'Automation & Robotics Solutions',
                    type: 'item',
                    url: '/tabs',
                    icon: icons.PrecisionManufacturingIcon,
                    breadcrumbs: false
                },
                // {
                //     id: 'manufacture',
                //     title: 'Manufacturing Engineering',
                //     type: 'item',
                //     url: '/manufacture',
                //     icon: icons.InfoIcon,
                //     breadcrumbs: false
                // },
                // {
                //     id: 'info',
                //     title: 'Automation & Robotics Solutions',
                //     type: 'item',
                //     url: '/software',
                //     icon: icons.SmartphoneIcon,
                //     breadcrumbs: false
                // }
            ]
        },
        {
            id: 'sample-page2',
            title: 'About Us',
            type: 'item',
            url: '/carousel',
            icon: MenuBookIcon,
            breadcrumbs: false
        },
        {
            id: 'favo',
            title: 'Favorites',
            type: 'item',
            url: '/favourite',
            icon: StarIcon,
            breadcrumbs: false
        },
        {
            id: 'contact',
            title: 'Contact Us',
            type: 'item',
            url: '/dashboard',//https://www.arigs.com/contact/
            icon: TtyIcon,
            breadcrumbs: false
        },
    ]
};

export default other;